import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FirebaseService from '@/services/firebase.service';
import ToastificationContent from '@/components/ToastificationContent';
export default {
  name: 'ValidateEmail',
  data: function data() {
    return {
      invalid: true,
      verified: false,
      email: '',
      password: '',
      confirmPassword: '',
      validationCode: undefined,
      mode: undefined,
      forceRenderKey: 0
    };
  },
  computed: {
    studentsUrl: function studentsUrl() {
      return "".concat(process.env.VUE_APP_ROOT_STUDENTS_URL, "auth/reauth");
    },
    adminUrl: function adminUrl() {
      return process.env.VUE_APP_ROOT_ADMIN_URL;
    }
  },
  beforeMount: function beforeMount() {
    this.validationCode = this.$route.query.oobCode;
    this.mode = this.$route.query.mode;

    if (this.mode === 'verifyEmail') {
      this.validateEmail();
    } else if (this.mode === 'resetPassword') {
      this.verifyPasswordResetCode();
    }
  },
  methods: {
    validateEmail: function validateEmail() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return FirebaseService.verifyEmail(_this.validationCode);

              case 3:
                _this.invalid = false;
                _this.verified = true;
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                _this.invalid = true;
                _this.verified = true;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    verifyPasswordResetCode: function verifyPasswordResetCode() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return FirebaseService.verifyPasswordResetCode(_this2.validationCode);

              case 2:
                _this2.email = _context2.sent;
                _this2.forceRenderKey += 1;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    resetPassword: function resetPassword() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return FirebaseService.confirmPasswordReset(_this3.validationCode, _this3.password);

              case 2:
                _this3.$toast({
                  component: ToastificationContent,
                  props: {
                    title: _this3.$t('#ToastMessage #Success Reset Password'),
                    icon: 'EditIcon',
                    variant: 'success'
                  }
                }, {
                  timeout: 2000,
                  draggable: true,
                  hideProgressBar: false
                });

                window.location.reload();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    goTo: function goTo(url) {
      window.location.href = url;
    }
  }
};